<template>
  <div>
    <default-sign-in v-if="application && application.signInComponent == 'default'" :options="application" />
    <default-sign-in v-if="application && application.signInComponent == 'taybullpay'" :options="application" />
    <legaldocflow-sign-in v-if="application && application.signInComponent == 'legaldocflow'" :options="application" />
  </div>
</template>

<script>

const DefaultSignIn = () => import('./SignIn.vue');
const LegaldocflowSignIn = () => import('./LegaldocflowSignIn.vue');

// const host = window.location.host;
let hostname = window.location.hostname;
// hostname = 'admin.legalworkflow365.com';
// hostname = 'admin.capture672.com';
// hostname = 'tlp.legaldocflow.com'; 
// hostname = 'app-pay.taybull.com'; 
// let parts = host.split('.');
// const subDomain = parts.length && parts[0] ? parts[0].toLowerCase() : '';

  export default {
    data: () => ({
      application: null,
      hostname: hostname,
      options: {}
    }),
    props: {
      source: String
    },
    methods: {
      clearSingleSignOn() {
        try {
          localStorage.removeItem('azure_id_token');
          localStorage.removeItem('azure_expires_at');
          localStorage.removeItem('azure_profile');
        } catch(error) {
          //
        }

      }

    },
    components: {
      DefaultSignIn,
      LegaldocflowSignIn
    },
    mounted() {
      this.clearSingleSignOn();
      const config = {
        'default': {application: 'taybull', signInComponent: 'default'},
        'admin.capture672.com': {application: 'capture672', signInComponent: 'default'},
        'app.capture672.com': {application: 'capture672', signInComponent: 'default'},
        'app-test.capture672.com': {application: 'capture672', signInComponent: 'default'},
        'admin-test.capture672.com': {application: 'capture672', signInComponent: 'default'},
        'admin.legalworkflow365.com': {application: 'legaldocflow', signInComponent: 'legaldocflow'},
        'admin-test.legalworkflow365.com': {application: 'legaldocflow', signInComponent: 'legaldocflow'},
        'app.legalworkflow365.com': {application: 'legaldocflow', signInComponent: 'legaldocflow'},
        'app-test.legalworkflow365.com': {application: 'legaldocflow', signInComponent: 'legaldocflow'},
        'admin.legaldocflow.com': {application: 'legaldocflow', signInComponent: 'legaldocflow'},
        'admin-test.legaldocflow.com': {application: 'legaldocflow', signInComponent: 'legaldocflow'},
        'app.legaldocflow.com': {application: 'legaldocflow', signInComponent: 'legaldocflow'},
        'tlp.legaldocflow.com': {application: 'legaldocflow', signInComponent: 'legaldocflow',  image: {
          url: 'https://legalworkflow365-public.s3.eu-west-2.amazonaws.com/tlp-logo.png',
          style: 'height: 40px; margin-top: 150px'
        }},
        'app-test.legaldocflow.com': {application: 'legaldocflow', signInComponent: 'legaldocflow'},
        'app-pay.taybull.com': {application: 'taybullpay', signInComponent: 'taybullpay',  image: {
          url: 'https://static.wixstatic.com/media/158464_000198d5938e4b9f9ea2e5344233b811~mv2.png/v1/fill/w_162,h_162,al_c,lg_1,q_85/logo_150x150.webp',
          style: 'height: 100px; margin-top: 5px; margin-bottom: 50px'
        }},
        'admin-pay.taybull.com': {application: 'taybullpay', signInComponent: 'taybullpay',  image: {
          url: 'https://static.wixstatic.com/media/158464_000198d5938e4b9f9ea2e5344233b811~mv2.png/v1/fill/w_162,h_162,al_c,lg_1,q_85/logo_150x150.webp',
          style: 'height: 100px; margin-top: 5px; margin-bottom: 50px'
        }},
      };

      const hostname = this.hostname;

      if(typeof config[hostname] != "undefined") {
        this.application = config[hostname];
      } else {
        this.application = config["default"];
      }

    },
    beforeCreate() {
    }
  }
</script>
